<template>
  <div class="container">
    <div class="banner" :style="'background-image:url('+ bannerUrl +')'">
      <Nav></Nav> 
    </div>
  
       <!--中间部分-->
      <div class="position">您的位置 ：实时公告> <span>{{weizhi}}</span></div>
      <div class="middle">
        <div class="tabs">
          <ul>
            <li v-for="(item,index) in position" :key="index" @click="jump(index,item.weizhi)" :class="value==index ? 'active1' : '' " ><img  :src="item.src" alt=""></li>
          </ul>
        </div>
        <div class="box" v-if="value===0">
          <div class="content-box" v-for="(item,index) in newsList" :key="index">
          <img :src="item.image" alt="">
          <div class="explain">
            <p class="onetext">{{item.title}}</p>
            <p class="twotext">{{item.introduce}}</p>
            <div class="threetext">
            <div class="button"><router-link tag="a" target="_blank" :to="{name:'NewsDetail',query:{id:item.id,Routingaddress:'Notice'}}" >查看详情</router-link></div>
              <p class="time">{{item.time}}</p>
            </div>
          </div>
        </div>
        </div>
        <div class="box" v-if="value===1">
          <div class="content-box" v-for="(item,index) in newsList" :key="index">
          <img :src="item.image" alt="">
          <div class="explain">
            <p class="onetext">{{item.title}}</p>
            <p class="twotext">{{item.introduce}}</p>
            <div class="threetext">
              <div class="button"><router-link tag="a" target="_blank" :to="{name:'NewsDetail',query:{id:item.id,Routingaddress:'Notice'}}" >查看详情</router-link></div>
              <p class="time">{{item.time}}</p>
            </div>
          </div>
        </div>
        </div>
        <div class="box" v-if="value===2">
          <div class="content-box" v-for="(item,index) in newsList" :key="index">
          <img :src="item.image" alt="">
          <div class="explain">
            <p class="onetext">{{item.title}}</p>
            <p class="twotext">{{item.introduce}}</p>
            <div class="threetext">
             <div class="button"><router-link tag="a" target="_blank" :to="{name:'NewsDetail',query:{id:item.id,Routingaddress:'Notice'}}" >查看详情</router-link></div>
              <p class="time">{{item.time}}</p>
            </div>
          </div>
        </div>
        </div>
        <!--翻页-->
        <div class="page">
        <el-pagination 
         background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  layout="prev, pager, next"
                  :page-size="5"
                  :total="total">
        </el-pagination>
        </div>
      </div>

      <!--底部-->
      <Footer></Footer>
  </div>
</template>
<script>
import Nav from '../../components/Nav'
import Footer from '../../components/Footer'
export default {
   components:{Nav,Footer},
   name:'Notice',
   data(){
     return{
      value:0,
      weizhi:'园区通知',
      pageVal:1,
      pageSize:5,
      currentPage: 1,
      bannerUrl:'',
      total: 0,
      id:'',
       position:[
        {weizhi:'园区通知',src:require('../../assets/yuanqutongzhi_03.png')},
        {weizhi:'新闻发布',src:require('../../assets/xinwenfabu_07.png')},
        {weizhi:'每周食谱',src:require('../../assets/meizhoushipu_10.png')},
       ],
        newsList:[
        {id:1,image:'',title:'',introduce:'',time:'2018-11-06'},
      ]

     }
   },
   methods:{
     jump(index,weizhi){
       this.pageVal = 1
       this.value=index;
       this.weizhi=weizhi;
       this.$http.post('/api/notice/getList', {
        page: this.pageVal,
        pageSize:this.pageSize,
        noPaginate:1,
        subType:this.weizhi
      }).then( (res)=> {
   
        var code=res.data.code;
        if(code===0){
        //  console.log(res.data.data.banner)
          this.newsList=res.data.data.list
          this.bannerUrl = res.data.data.banner
          this.id=res.data.data.list.id
           this.total=res.data.data.total
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
         this.pageSize=val;
         this.getList()
      },
    handleCurrentChange(val) {
         this.pageVal=val
         this.getList()
      },
    getListone() {
        this.$http.post('/api/notice/getList', {
          page: this.pageVal,
          pageSize:this.pageSize,
          noPaginate:1,
          subType:"园区通知"
        }).then( (res)=> {
          var code=res.data.code;
          if(code===0){
          // console.log(res.data.data.banner)
            this.newsList=res.data.data.list
            this.bannerUrl = res.data.data.banner
            this.id=res.data.data.list.id
             this.total=res.data.data.total
          }
        }).catch(function (error) {
          // console.log(error);
      });
    },
    getList() {
      this.$http.post('/api/notice/getList', {
        page: this.pageVal,
        pageSize:this.pageSize,
        noPaginate:1,
        subType:this.weizhi
          }).then( (res)=> {
          var code=res.data.code;
          if(code===0){
            this.newsList=res.data.data.list
            this.bannerUrl = res.data.data.banner
            this.id=res.data.data.list.id
             this.total=res.data.data.total
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    }
   },
   created(){
     this.getListone()
     this.getList()
   }
}
</script>
<style scoped>
.container{
 background-color:rgb(244,247,250);
 min-width: max-content;
 min-width: -moz-max-content;
}

body{
  position: relative;
}
 .active1{
   background-color: rgb(247, 180, 31) !important;
 }
.tabs{
  float: left;
  /* margin-left: -40px; */
}
.box{
  width: 990px;
  margin-left: 210px;
}
.tabs ul li{
  list-style: none;
  background-color: rgb(191, 191, 191);
  margin-bottom: 35px;
  padding: 15px 25px 15px 25px;
  border-radius: 15px;
  color: white;
 
}
.tabs ul li:hover{
  cursor: pointer;
}
.banner{
  overflow: hidden !important;
}
.banner{
  position: relative;
  background-image: url('../../assets/banner3.png');
  width: 100%;
  min-width: 1200px;
  height: 366px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.position{
  margin: 0 auto;
  width: 990px;
  text-align: right;
  margin-top: 40px;
  color: rgb(164, 164, 164);
  font-size: 16px;
  }
  .position span{
    color: rgb(247, 184, 46)
  }
  .middle{
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;   
  }
  .middle .content-box{
   
    width: 990px;
   
    height: 210px;
    /* display: flex; */
    /* justify-content: space-around; */
    border-radius:25px;
    overflow: hidden;
    background-color: rgb(255, 255, 255);
    margin-bottom: 35px;
    border: 2px solid rgb(229, 238, 247)
  }
  .middle .content-box:hover{
     box-shadow:2px 5px 8px 2px #ccc;
  }
  .middle .content-box:hover  .threetext .button{
     background-color: rgb(247, 184, 46)
  }
  .content-box img{
    width: 353px;
    height: 210px;
  }
  .explain{
    width: 637px;
    float:right;
    margin: 0 auto;
    height: 210px;
  }
  .explain .onetext{
    width: 600px;
    margin: 0 auto;
    font-size: 20px;
    color: rgb(64, 64, 64);
    font-weight: bolder;
    margin-top: 35px;
     overflow: hidden;
    text-overflow: ellipsis;
    display: box;
    display: -webkit-box;
    -webkit-line-clamp: 1;
     /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
  .explain .twotext,.explain .time{
   
     font-size: 14px;
     color: rgb(176, 176, 176)
  }
  .explain .twotext{
    width: 595px;
    margin: 0 auto;
    margin-top: 25px;
    line-height: 25px;
     height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: box;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
  .threetext .button{
    float: left;
    font-size: 16px;
    background: rgb(191, 191, 191);
    color: white;
    border-radius:20px;
    padding: 5px 20px;
      line-height: 25px;
  }
   .threetext .button a{
    color: white;
    text-decoration: none;
  }
  .threetext .button:hover{
   
    cursor: pointer;
  }
   .threetext .time{
    float: right;
  }
  .threetext{
    width: 590px;
    margin: 0 auto;
     margin-top: 25px;
  }
 

</style>

<style>
 .el-pagination{
 text-align: center;
 margin-top: 40px;
}
.page .el-pagination.is-background .el-pager li {
  height: 40px;
  line-height: 41px;
  background-size: 30px 40px;
  background-color: transparent;
  background-image: url('../../assets/egg.png') !important;
}
 .page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-image: url('../../assets/egg-yellow.png') !important;
  background-color: transparent;
  color: #fff !important
}
 .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-image: url('../../assets/egg-yellow.png') !important;
  background-color: transparent;
  color: #fff;
}
 .page .el-pagination.is-background button.btn-prev,
 .page .el-pagination.is-background button.btn-next {
  height: 40px;
  line-height: 40px;
  background-size: 30px 40px;
  background-color: transparent;
  background-image: url('../../assets/egg.png') !important;
}
 .page .el-pagination.is-background button.btn-prev > i,
 .page .el-pagination.is-background button.btn-next > i {
  margin-top: 7px;
}
.page .el-pagination .el-pager .number{
  background-image: url('../../assets/egg.png') !important;
  color: #fff ;
  background-color: #fff;
}
.page .el-pagination.is-background .el-pager li {
  background-image: url('../../assets/egg.png') !important;
  color: rgb(152, 152, 152) ;
  /* background-color: #fff; */
}
</style>



// WEBPACK FOOTER //
// src/pages/pcPages/Notice.vue